export const environment = {
    production: false,
    /** Where a promotion from this environment lands. CI is the bottom of the chain: work promoted here lands on sandbox. */
    promotionTarget: 'Sandbox',
    tenantClientId: 'Launchcan',
    applicationApi: 'https://pmp-applicationapi-ci.mangosmoke-5bcb3521.uksouth.azurecontainerapps.io/api/v1',
    userApi: 'https://pmp-userapi-ci.mangosmoke-5bcb3521.uksouth.azurecontainerapps.io/api/v1',
    programmeApi: 'https://pmp-programmeapi-ci.mangosmoke-5bcb3521.uksouth.azurecontainerapps.io/api/v1',
    documentApi: 'https://pmp-documentapi-ci.mangosmoke-5bcb3521.uksouth.azurecontainerapps.io/api/v1',
    workflowApi: 'https://pmp-workflowapi-ci.mangosmoke-5bcb3521.uksouth.azurecontainerapps.io/api/v1',
    formApi: 'https://pmp-formapi-ci.mangosmoke-5bcb3521.uksouth.azurecontainerapps.io/api/v1',
    auth0: {
        domain: 'pmp-ci.eu.auth0.com',
        clientId: 'w6LcU0k5jw3XtsnphF5SScaashnWTDcs',
        cacheLocation: 'localstorage' as const, // Persist tokens across page refreshes
        authorizationParams: {
            redirect_uri: window.location.origin,
            audience: 'https://pmp-logicalapi-ci',
            post_sign_up_url: window.location.href,
            custom_claim_prefix: 'pmp-ci.eu',
            connection: 'email',
            // Removed 'prompt: login' - it was forcing re-authentication on every page load
        },
    },
    httpInterceptor: {
        allowedList: [
            {
                uri: 'https://pmp-formapi-ci.mangosmoke-5bcb3521.uksouth.azurecontainerapps.io/api/*',
                tokenOptions: {
                    authorizationParams: {
                        audience: 'https://pmp-logicalapi-ci'
                    }
                }
            },
            {
                uri: '/api/*',
                tokenOptions: {
                    authorizationParams: {
                        audience: 'https://pmp-logicalapi-ci' // Optional: if you have an API
                    }
                }
            },
            {
                uri: 'https://pmp-applicationapi-ci.mangosmoke-5bcb3521.uksouth.azurecontainerapps.io/api/*',
                tokenOptions: {
                    authorizationParams: {
                        audience: 'https://pmp-logicalapi-ci'
                    }
                }
            },
            {
                uri: 'https://pmp-applicationapi-ci.mangosmoke-5bcb3521.uksouth.azurecontainerapps.io/api/v1/*',
                tokenOptions: {
                    authorizationParams: {
                        audience: 'https://pmp-logicalapi-ci'
                    }
                }
            },
            {
                uri: 'https://pmp-userapi-ci.mangosmoke-5bcb3521.uksouth.azurecontainerapps.io/api/*',
                tokenOptions: {
                    authorizationParams: {
                        audience: 'https://pmp-logicalapi-ci'
                    }
                }
            },
            {
                uri: 'https://pmp-programmeapi-ci.mangosmoke-5bcb3521.uksouth.azurecontainerapps.io/api/*',
                tokenOptions: {
                    authorizationParams: {
                        audience: 'https://pmp-logicalapi-ci'
                    }
                }
            },
            {
                uri: 'https://pmp-documentapi-ci.mangosmoke-5bcb3521.uksouth.azurecontainerapps.io/api/*',
                tokenOptions: {
                    authorizationParams: {
                        audience: 'https://pmp-logicalapi-ci'
                    }
                }
            },
            {
                uri: 'https://pmp-workflowapi-ci.mangosmoke-5bcb3521.uksouth.azurecontainerapps.io/api/*',
                tokenOptions: {
                    authorizationParams: {
                        audience: 'https://pmp-logicalapi-ci'
                    }
                }
            }
        ]
    }
}


